export default [
    {
        name: 'Pleitos',
        url: '/pleitos/ucic',
        icon: 'fa fa-file-text-o',
        regras: 'PLEITOS-UCIC-00',
        badge: {
            variant: 'primary',
            text: 'UCIC'
        }
    }
]